<div
  [fxLayout]="layoutContainer.layout"
  [fxLayoutAlign]="layoutContainer.align"
  [fxLayoutGap]="layoutContainer.gap"
>
  <display class="display" #display></display>
</div>
